import { c as _c } from "react/compiler-runtime";
import { useField } from 'formik';
import { Fragment, ReactNode, useEffect, useState } from 'react';
import useSWR from 'swr';
import Badge from '../../base/Badge';
import Button, { ClickableArea } from '../../base/Button';
import { StyledCardSection } from '../../base/Card';
import Icon, { IconName } from '../../base/Icon';
import Loading from '../../base/Loading';
import Skeleton from '../../base/Skeleton';
import Tabs from '../../base/Tabs';
import Text from '../../base/Text';
import Dropdown from '../../Dropdown';
import { Div } from '../../helpers/StyledUtils';
import Search from '../../Search';
import { StyledSelect } from './SelectInput';
export type Item = {
  id: string;
  label: string;
  description?: string;
  icon: IconName;
  category?: string;
};
interface Props {
  name: string;
  search?: boolean;
  search_placeholder?: string;
  categories?: {
    label: string;
    key: string;
  }[];
  getItemsKey: (search_term: string, category?: string) => string;
  getItems: (search_term: string, category?: string) => Promise<Item[]>;
  getItemsFooter?: (search_term: string, category?: string) => ReactNode;
  show_category_badge?: boolean;
  minimal?: boolean;
  outline?: boolean;
  onSelect?: (value: string) => void;
}
const ItemListPickerInput: React.FC<Props> = t0 => {
  const $ = _c(46);
  const {
    name,
    categories,
    getItems,
    getItemsKey,
    getItemsFooter,
    search_placeholder: t1,
    search: t2,
    show_category_badge: t3,
    outline: t4,
    onSelect
  } = t0;
  const search_placeholder = t1 === undefined ? "Search..." : t1;
  const search = t2 === undefined ? true : t2;
  const show_category_badge = t3 === undefined ? true : t3;
  const outline = t4 === undefined ? false : t4;
  const [t5,, t6] = useField(name);
  const {
    value
  } = t5;
  const {
    setValue,
    setTouched
  } = t6;
  const [fetch_items, setFetchItems] = useState(false);
  const [search_term, setSearchTerm] = useState("");
  const [category, setCategory] = useState("all");
  const [t7,, t8] = useField(`search.${name}`);
  const {
    value: search_value
  } = t7;
  const {
    setValue: setSearchValue
  } = t8;
  let t9;
  if ($[0] !== search_term || $[1] !== setSearchValue) {
    t9 = () => {
      setSearchValue(search_term);
    };
    $[0] = search_term;
    $[1] = setSearchValue;
    $[2] = t9;
  } else {
    t9 = $[2];
  }
  let t10;
  if ($[3] !== search_term || $[4] !== search_value || $[5] !== setSearchValue) {
    t10 = [search_term, search_value, setSearchValue];
    $[3] = search_term;
    $[4] = search_value;
    $[5] = setSearchValue;
    $[6] = t10;
  } else {
    t10 = $[6];
  }
  useEffect(t9, t10);
  let t11;
  if ($[7] !== category || $[8] !== getItemsKey || $[9] !== search_term) {
    t11 = getItemsKey(search_term, category);
    $[7] = category;
    $[8] = getItemsKey;
    $[9] = search_term;
    $[10] = t11;
  } else {
    t11 = $[10];
  }
  const items_key = t11;
  let t12;
  if ($[11] !== category || $[12] !== getItems || $[13] !== search_term) {
    t12 = () => getItems(search_term, category);
    $[11] = category;
    $[12] = getItems;
    $[13] = search_term;
    $[14] = t12;
  } else {
    t12 = $[14];
  }
  const {
    data
  } = useSWR((fetch_items || value) && items_key ? `${items_key}::list-picker-${name}` : null, t12);
  let t13;
  if ($[15] !== category || $[16] !== getItemsFooter || $[17] !== search_term) {
    t13 = getItemsFooter ? getItemsFooter(search_term, category) : null;
    $[15] = category;
    $[16] = getItemsFooter;
    $[17] = search_term;
    $[18] = t13;
  } else {
    t13 = $[18];
  }
  const items_footer = t13;
  let t14;
  if ($[19] !== data || $[20] !== value) {
    t14 = value && data?.find(item => item.id === value);
    $[19] = data;
    $[20] = value;
    $[21] = t14;
  } else {
    t14 = $[21];
  }
  const current_item = t14;
  const is_resolving_value = !!value && !current_item && !data;
  const has_categories = !!categories && categories.length > 0;
  let t15;
  if ($[22] !== fetch_items) {
    t15 = () => !fetch_items && setFetchItems(true);
    $[22] = fetch_items;
    $[23] = t15;
  } else {
    t15 = $[23];
  }
  let t16;
  if ($[24] !== current_item || $[25] !== is_resolving_value || $[26] !== outline) {
    t16 = (opened, toggle) => <StyledSelect error={false} has_value={!!current_item}><Button block={true} ghost={true} large={true} outline={outline} muted={!current_item} onClick={() => toggle(true)}><Div w={100} flex={{
          align: "center",
          gap: 2
        }}>{!!current_item && current_item?.icon && <Icon icon={current_item?.icon} muted={true} />}{is_resolving_value ? <Skeleton small={true} w={{
            px: 120
          }} /> : <Text w={100} align="left">{current_item?.label || "Select..."}</Text>}</Div></Button><Icon icon="expand_all" muted={!current_item} right={-7} p={{
        t: 2
      }} style={{
        position: "absolute",
        cursor: "pointer"
      }} /></StyledSelect>;
    $[24] = current_item;
    $[25] = is_resolving_value;
    $[26] = outline;
    $[27] = t16;
  } else {
    t16 = $[27];
  }
  let t17;
  if ($[28] !== categories || $[29] !== category || $[30] !== data || $[31] !== has_categories || $[32] !== items_footer || $[33] !== onSelect || $[34] !== search || $[35] !== search_placeholder || $[36] !== search_term || $[37] !== setTouched || $[38] !== setValue || $[39] !== show_category_badge || $[40] !== value) {
    t17 = toggle_0 => <><StyledCardSection p={{
        x: has_categories ? 3 : 0,
        t: has_categories ? 3 : 0,
        b: 0
      }}>{search && <Search onChange={setSearchTerm} value={search_term} placeholder={search_placeholder} borderless={!has_categories} focus={true} small={true} />}{has_categories && <Div p={{
          t: 2
        }}><Tabs compact={true} border={false} active_tab={category || "all"} onTabSelected={key => setCategory(key)} tabs={[{
            key: "all",
            label: "All"
          }, ...categories]} /></Div>}</StyledCardSection><StyledCardSection max_h={{
        px: 240
      }} scroll={true} p={{
        y: items_footer ? 2 : 1,
        x: 1
      }}>{!data && <Div p={{
          x: 3,
          y: 2
        }} flex={{
          align: "center",
          justify: "center"
        }}><Loading /></Div>}{data && data.length === 0 && <Text p={{
          x: 3,
          y: 2
        }} muted={true}>No results found</Text>}{data && data.map((item_0, i) => {
          const isSelected = item_0.id === value;
          return <Fragment key={item_0.id}><ClickableArea p={{
              x: 2,
              y: 1.5
            }} rounded={true} flex={{
              justify: "space-between",
              align: "center"
            }} data-selected={isSelected ? "true" : "false"} onClick={() => {
              setValue(item_0.id);
              setTouched(true, false);
              toggle_0(false);
              setSearchTerm("");
              onSelect?.(item_0.id);
            }}><Div flex={{
                align: "center",
                gap: 2
              }} w={100} style={{
                overflow: "hidden",
                flex: 1
              }}><Icon icon={item_0.icon} muted={true} pointer={true} /><Div flex={{
                  align: "center",
                  gap: 1
                }} w={100}><Text dark={true}>{item_0.label}</Text>{item_0.description && <Text size="xs" muted={true} ellipsis={true} max_w={{
                    px: 400
                  }}>({item_0.description})</Text>}</Div>{isSelected && <Icon primary={true} icon="success_circle" />}</Div>{show_category_badge && item_0.category && <Badge neutral={true}>{item_0.category}</Badge>}</ClickableArea></Fragment>;
        })}</StyledCardSection>{items_footer && <StyledCardSection>{items_footer}</StyledCardSection>}</>;
    $[28] = categories;
    $[29] = category;
    $[30] = data;
    $[31] = has_categories;
    $[32] = items_footer;
    $[33] = onSelect;
    $[34] = search;
    $[35] = search_placeholder;
    $[36] = search_term;
    $[37] = setTouched;
    $[38] = setValue;
    $[39] = show_category_badge;
    $[40] = value;
    $[41] = t17;
  } else {
    t17 = $[41];
  }
  let t18;
  if ($[42] !== t15 || $[43] !== t16 || $[44] !== t17) {
    t18 = <Dropdown placement="bottom-start" parent_width={true} scroll_to_selected={true} onToggle={t15} renderToggle={t16}>{t17}</Dropdown>;
    $[42] = t15;
    $[43] = t16;
    $[44] = t17;
    $[45] = t18;
  } else {
    t18 = $[45];
  }
  return t18;
};
export default ItemListPickerInput;